import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import { UserSelfApplyList } from './UserSelfApplyList';

export const userSelfApplyResource = {
  list: UserSelfApplyList,
  icon: PlaylistAddCheckIcon,
};
